export default "<div *ngFor=\"let hand of hands\">\n  <hand [cards]=\"hand\" [active]=\"true\"></hand>\n</div>"